



import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import Btn from "../../shared/button/Btn"
import { addAiChatTitle, addChatSubTitleWithQuestion, addNewQuestionLocal, deleteAIChatSubTitle, deleteChatTitle, setAiChatDetails } from "../../../features/aiControl/aiControlSlice"
import AIQuestionItemAdd from "../../aiControl/AIQuestionItemAdd"
import InputNewSubTitle from "../../shared/input/ai/InputNewSubTitle"
import InputText from "../../shared/input/new/InputText"
import PageTopTitle from "../../shared/PageTopTitle"
import moment from "moment"
import { textBoldMakerDouble } from "../../../helper/textBoldMaker"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1200px;
        height: 600px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border-radius: 10px;
        padding: 20px 0;
        padding-bottom: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;

        .content{
            width: 100%;
            padding: 40px;
            padding-top: 50px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 20px;
            color: ${({theme}) => theme.mainTextColor};
            height: calc(600px - 80px);
            overflow: auto;

            .chat-container{
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 35px;
            }

        }

        .btn-container{
            display: flex;
            justify-content: center;
            align-items: center;
            height: 80px;
            width: 100%;
            border-top: 1px solid ${({theme}) => theme.mainBorderColor};
        }
    }
`

const MessageItem = styled.div`
    width: 100%;
    display: flex;
    justify-content: ${({isSelf}) => isSelf ? "flex-end" : "flex-start"};

    .message-container{
        width: auto !important;
        max-width: 70% !important;
        background-color: ${({theme, isSelf}) => isSelf ? "var(--color-main)" : theme.secondaryBgColor};
        color: ${({theme, isSelf}) => isSelf ? "#fff" : theme.mainTextColor};
        border-radius: 5px;
        padding: 15px 20px;
        width: 100%;

        .message-text{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-sm);
            line-height: 1.4;

            .bold{
                font-weight: var(--font-weight-xl);
            }
        }

        .message-details{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 20px;
            gap: 20px;



            .name{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
            }

            .date-container{
                display: flex;
                align-items: center;
                gap: 10px;

            }
        }
    }

    
`

const AiMobileSingleChatDetailsModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)

    const { lockScroll, unlockScroll } = useScrollLock();

    const {aiChatItemDetails} = useSelector(state => state.aiControl)

    const [reversedList, setReversedList] = useState(null)

    useEffect(() => {
        setReversedList([...aiChatItemDetails])
    },[aiChatItemDetails])
 

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
            dispatch(setAiChatDetails([]))
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])


  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
        <PageTopTitle title={"Yapay Zeka Sohbet Detayı"}/>
        <div className="content">

            <div className="chat-container">
                {
                    reversedList?.reverse()?.map(item => (
                        <MessageItem isSelf={item.questionOrAnswer === 1}>
                            <div className="message-container">
                                <p className="message-text" dangerouslySetInnerHTML={{ __html: textBoldMakerDouble(item.message)?.replace(/\n/g, "<br>")}}></p>
                                <div className="message-details">
                                    <div className="name">{item.questionOrAnswer === 1 ? item.name : "Akıllı Kamyon"}</div>
                                    <div className="date-container">
                                        <div className="name">{moment(item.createDate).add(3, "hours").format("LT")}</div>
                                        <div className="name">{moment(item.createDate).add(3, "hours").format("L")}</div>
                                    </div>
                                </div>
                            </div>
                        </MessageItem>
                    ))
                }

            </div>
        </div>
        <div className="btn-container">
            <Btn bgColor="#E85446" color="#fff" width={"140px"} handleClick={() => dispatch(showModal(null))}>Kapat</Btn>
        </div>
    </div>
</ModalContainer>
  )
}

export default AiMobileSingleChatDetailsModal